<template>
  <div
    class="the-loader"
  >
    <div class="stones__container">
      <div class="stone stone--top" />
      <div class="stone stone--2" />
      <div class="stone stone--1" />
      <div class="stone stone--bottom" />
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss">
.the-loader {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .stone {
    animation: scale-easeOutElastic 3s;
    animation-fill-mode: forwards;
    opacity: 0;
    background: radial-gradient(at 0 0, #a7a7a7, #90908c);
    margin: 0 auto;

    &--top {
      height: 60px;
      width: 80px;
      border-radius: 30% 60% 60% 40% / 50% 51% 60% 50%;
      transform-origin: 35% bottom;
      animation-delay: 2s;
    }

    &--2 {
      width: 150px;
      height: 45px;
      border-radius: 27% 50% 50% 50% / 50% 53% 50% 50%;
      transform-origin: 40% bottom;
      animation-delay: 1s;
    }

    &--1 {
      width: 180px;
      height: 50px;
      border-radius: 50% 27% 50% 50% / 50% 53% 50% 50%;
      transform-origin: 65% bottom;
    }

    &--bottom {
      width: 210px;
      height: 40px;
      border-radius: 36% 30% 37% 41% / 50% 53% 50% 50%;
      transform-origin: 65% bottom;
      animation: none;
      opacity: 1;
    }
  }

  @keyframes scale-easeOutElastic {
    0% {
      transform: rotateZ(0deg);
      opacity: 1;
    }

    16% {
      transform: rotateZ(-5deg);
      opacity: 1;
    }

    28% {
      transform: rotateZ(4deg);
      opacity: 1;
    }

    44% {
      transform: rotateZ(-4deg);
      opacity: 1;
    }

    59% {
      transform: rotateZ(2deg);
      opacity: 1;
    }

    73% {
      transform: rotateZ(-1deg);
      opacity: 1;
    }

    88% {
      transform: rotateZ(1deg);
      opacity: 1;
    }

    100% {
      transform: rotateZ(0deg);
      opacity: 1;
    }
  }

  .stones__container {
    text-align: center;
  }
}
</style>
